<template>
  <div class="container">
    <!-- 顶部图片区域 -->
    <div class="top-ad" style="height: 13.5rem;display: flex;">
      <div style="width: 45%;"><img src="/static/img/ad.png" alt="" style="width: 100%; height: auto;max-height: 100%;">
      </div>
      <div style="width: 10%;text-align: center;" v-if="user.shareBonus>0">
        <div style="padding: 0.5rem 0;font-size: 1.2rem;font-weight: 600;">扫码开通会员</div>
        <!-- 自定义颜色 -->
        <div class="qr-code-wrapper">
          <qrcode :text="qrCodeValue" :size="130" :color-dark="'#333333'" :color-light="'#ffffff'"></qrcode>
        </div>
      </div>

      <div style="width: 10%;text-align: center;" v-else>
        <div style="padding: 0.5rem 0;font-size: 1.2rem;font-weight: 600;">奇顺交规</div>
        <!-- 自定义颜色 -->
        <div class="qr-code-wrapper">
          <img src="/static/img/icon.jpg" alt="" style="width: 8.25rem;">
          <!-- <img :src="shareQrcode" alt="" style="width: 6.25rem;"> -->
        </div>
      </div>

      <div
        style="width: 45%;background: url('/static/img/home2.jpg') no-repeat center center;background-size: 100% 100%;color: #fff;text-align: center;justify-content: center;display: flex;flex-direction: column;align-items: center;">
        <div style="font-size: 2.5rem;">科一科四技巧辅导题库</div>
        <div style="font-size: 1.5rem;background-color: red;padding: 0.3rem 1.5rem;border-radius: 3rem;">真人视频讲解</div>
        <div style="display: flex;flex-direction: row;margin-top: 0.625rem;cursor: pointer;">
          <div style="border: 0.0625rem solid #f0f0f0;padding: 0.625rem 1.875rem;">
            <div class="font-size-selector" style="position: relative;">
              <!-- 触发按钮 -->
              <div class="dropdown-trigger" style="cursor: pointer;color:#fff;font-size: 1.05rem;"
                @click="isOpen = !isOpen">
                字号{{FontSizeValue || '调节'}}<i class="el-icon-arrow-down el-icon--right"></i>
              </div>

              <!-- 下拉菜单 -->
              <div class="dropdown-menu" v-if="isOpen"
                style="position: absolute; top: 100%; left: 0; margin-top: 0.7rem; background: #fff; border: 1px solid #f0f0f0; border-radius: 4px; z-index: 9999; min-width: 120px;">
                <div class="dropdown-item" style="padding: 8px 16px; cursor: pointer; color: #333;"
                  v-for="size in sizes" :key="size.value" @click="handleSizeSelect(size.value)">
                  {{ size.label }}
                </div>
              </div>
            </div>
            <!--            <el-dropdown style="cursor: pointer;color:#fff;font-size: 1.05rem;" @command="setFontSize">
              <span class="el-dropdown-link">
                字号{{FontSizeValue || '调节'}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">默认</el-dropdown-item>
                <el-dropdown-item command="26">26号</el-dropdown-item>
                <el-dropdown-item command="28">28号</el-dropdown-item>
                <el-dropdown-item command="30">30号</el-dropdown-item>
                <el-dropdown-item command="32">32号</el-dropdown-item>
                <el-dropdown-item command="34">34号</el-dropdown-item>
                <el-dropdown-item command="36">36号</el-dropdown-item>
                <el-dropdown-item command="38">38号</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </div>
          <div style="border: 0.0625rem solid #f0f0f0;padding: 0.625rem 1.875rem;margin-left: 1.25rem;"
            @click="showEndTime">账号有效期</div>
          <div style="border: 0.0625rem solid #f0f0f0;padding: 0.625rem 1.875rem;margin-left: 1.25rem;" @click="toUser">
            账号中心</div>
          <div style="border: 0.0625rem solid #f0f0f0;padding: 0.625rem 1.875rem;margin-left: 1.25rem;" @click="open">
            退出账号</div>
        </div>
      </div>
    </div>
    <!-- 分割线 -->
    <div class="middle-thick-divider"></div>

    <div class="exam-menu-container">
      <div class="right-section">
        <div class="function-grid">
          <div class="function-item"
            :class="{ 'car-type-check': carTypeCheckIndex===index ,'subject-check':subjectCheckIndex===item.subject_key ,'alignItemsToLeft':item.type==1}"
            v-for="(item, index) in vehicleTypes" :key="index" @click="selectFunction(item,index)">
            <div v-if="item.type==0">
              <div style="border-bottom: 1px solid gray;">
                <img :src="item.image" alt="icon" class="function-item-img">
                <span class="type-title">{{ item.title }}</span>
              </div>
              <span class="type-sub">{{ item.sub }}</span>
            </div>
            <div v-if="item.type==1"
              style="display: flex;align-items: center;justify-content: center;margin-left: 2.5rem;">
              <div class="item-icon">
                <img :src="item.image" alt="icon" class="function-item-img2">
              </div>
              <span style="margin-left: 1rem;font-size: 2.3rem;">{{ item.text }}</span>
            </div>
          </div>
        </div>

      </div>

      <!-- 中间 VIP、模拟考试区域 -->
      <div class="middle-section">
        <div class="vip-box" @click="goVip">
          <!--          <div class="diamond">♦</div>
          <div class="vip-text">VIP</div>
          <div class="vip-desc">尊享特权</div> -->
        </div>
        <div class="simulate-exam" @click="goSimulate">
          <!--          <img src="/static/img/vip_classify_2.png" class="function-item-img2">
          <span>模拟考试</span> -->
        </div>
      </div>

      <!-- 右侧功能区域 -->
      <div class="right-section">
        <div class="function-grid">
          <div class="function-item" v-for="(item, index) in functionItems" :key="index" @click="goFunction(item)"
            style="justify-content: left;flex-direction:row;align-items: center;display: flex;padding: 1.72rem 0;">
            <div class="item-icon" style="padding-left: 2rem;">
              <img :src="item.image" alt="icon" class="function-item-img2">
            </div>
            <span style="margin-left: 1rem;font-size: 2.3rem;">{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <img :src="subjectCheckIndex==1?'/static/img/subject1.png':'/static/img/subject4.png'"
            style="width: 100%;position: relative;">
          <div @click="closeModal"
            style="width: 3.125rem;height: 3.125rem;z-index: 9999;position: absolute;top: 5rem;left: 4.0625rem">
          </div>
          <div style="display: flex;width: 100%;border: 1px solid #d1d1d1;height: 100%;">
            <div style="background-color: #f0f0f0;width: 100%;display: flex;font-size: 1.5rem;">
              <div style="flex: 1;border: 1px solid #999;">
                <div style="padding: 9rem 0 0 2.5rem;">
                  <div class="rule-item">考试须知</div>
                  <div class="rule-item">1. 遵守考场纪律，服从监考人员指挥。</div>
                  <div class="rule-item">2. 进入考场、手机关机。禁止抽烟，禁止吃零食。</div>
                  <div class="rule-item">3. 未经工作人员允许，考生禁止随意出入考场。</div>
                  <div class="rule-item">4. 考场内禁止大声喧哗，禁止随意走动。</div>
                  <div class="rule-item">5. 考试中认真答题，不准交头接耳。</div>
                  <div class="rule-item">6. 考试中不准冒名顶替，不准弄虚作假。</div>
                  <div class="rule-item">7. 注意考场卫生，禁止随地吐痰，禁止乱扔纸屑。</div>
                  <div class="rule-item">8. 爱护公物及考试设备。</div>
                </div>
              </div>
              <div style="flex: 1;border: 1px solid #999;border-left: none;">
                <div style="padding: 9rem 0 0 2.5rem;">
                  <div>理论考试01号考台</div>
                  <div style="margin-top: 1.25rem;color: red;">身份证号: 012345678901234567</div>
                  <div style="color: red;">考生姓名: 奇顺交规</div>
                  <div style="text-align: center;">
                    <button
                      style="width: 8.75rem;height: 3.125rem;background-color: white;border: 1px solid #ccc;font-size: 1rem;line-height: 3.125rem;font-weight: 500;margin: 1.25rem 0;"
                      @click="goExam('模拟考试','CaseScene')">确认</button>
                  </div>
                  <div class="tip-text">点击“确认”按钮开始考试！</div>
                  <div class="operation-tip">操作提示: 每题考试答案确定后，点击【下一题】，电脑立即判定所选答案，如选择错误，系统将提示正确答案，提示后不允许修改答案。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import VueQrcode from 'vue-qrcode-component'
  export default {
    components: {
      qrcode: VueQrcode
    },
    name: 'home',
    data() {
      return {
        qrCodeValue: '',
        selectedVehicle: null,
        selectedBusiness: null,
        carTypeCheckIndex: 0, // 车型索引
        subjectCheckIndex: 1, // 科目索引
        // 车辆类型数据
        vehicleTypes: [{
            // 添加图片路径
            image: '/static/img/car1.png',
            title: '小车',
            sub: 'C1/C2/C3/C5/C6',
            type: 0,
            subject: '',
            car_type: 1
          },
          {
            // 添加图片路径
            image: '/static/img/kemu.png',
            text: '科目一',
            type: 1,
            subject: 1,
            subject_key: 1 // 用于高亮已选择
          },
          {
            // 添加图片路径
            image: '/static/img/car2.png',
            title: '货车',
            sub: 'A2/B2',
            type: 0,
            subject: '',
            car_type: 2
          },
          {
            // 添加图片路径
            image: '/static/img/kemu.png',
            text: '科目四',
            type: 1,
            subject: 4,
            subject_key: 3
          },
          {
            // 添加图片路径
            image: '/static/img/car3.png',
            title: '客车',
            sub: 'A1/A3/B1',
            type: 0,
            subject: '',
            car_type: 3
          },
          {
            // 添加图片路径
            image: '/static/img/kemu.png',
            text: '注销恢复',
            type: 1,
            subject: 6,
            subject_key: 5
          },
          {
            // 添加图片路径
            image: '/static/img/car4.png',
            title: '摩托车',
            sub: 'D/E/F',
            type: 0,
            subject: '',
            car_type: 4
          },
          {
            // 添加图片路径
            image: '/static/img/kemu.png',
            text: '满分学习',
            type: 1,
            subject: 5,
            subject_key: 7
          }
          // ,
          // {
          //   // 添加图片路径
          //   image: '/static/img/cart4.fb4bc6c.png',
          //   title: '三力测试',
          //   sub: '三力测试',
          //   type: 0,
          //   subject: '',
          //   car_type: 1 // 三力测试的时候，定义车型为小车
          // },
          // {
          //   // 添加图片路径
          //   image: '/static/img/vip_classify_2.png',
          //   text: '三力测试',
          //   type: 1,
          //   subject: 7,
          //   subject_key: 9
          // }
        ],
        // 右侧功能项数据
        functionItems: [{
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '强化题',
            Action: '强化题库'
          },
          {
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '收藏题',
            Action: '收藏题'
          },
          {
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '考前密卷',
            Action: '考前密卷'
          },
          {
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '成绩与错题',
            Action: '成绩与错题'
          },
          {
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '分类练习',
            Action: '分类练习'
          },
          {
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '三力测试',
            Action: '三力测试'
          },
          {
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '地方题库',
            Action: '地方题库'
          },
          {
            // 添加图片路径
            image: '/static/img/xunlian.png',
            text: '使用流程',
            Action: '使用流程'
          }
        ],
        showModal: false, // false  true
        user: {},
        FontSizeValue: '', // 设置字号缓存，在考试的时候，题目显示的字体按此字号显示
        shareQrcode: '',

        childAuth: true, // 教练开出来的子账号，不允许练题
        isOpen: false,
        FontSizeValue: '',
        sizes: [{
            label: '默认',
            value: '0'
          },
          {
            label: '26号',
            value: '26'
          },
          {
            label: '28号',
            value: '28'
          },
          {
            label: '30号',
            value: '30'
          },
          {
            label: '32号',
            value: '32'
          },
          {
            label: '34号',
            value: '34'
          },
          {
            label: '36号',
            value: '36'
          },
          {
            label: '38号',
            value: '38'
          },
        ]
      }
    },
    watch: {
      showModal(val) {
        if (val) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    },
    mounted() {
      // 当组件挂载时，设置 body 的背景颜色
      document.body.style.backgroundColor = '#4da6ff';

      const selected_carTypeCheckIndex = sessionStorage.getItem('selected_carTypeCheckIndex');
      console.log('selected_carTypeCheckIndex', selected_carTypeCheckIndex)
      if (selected_carTypeCheckIndex) {
        this.carTypeCheckIndex = parseInt(selected_carTypeCheckIndex);
      } else {
        this.carTypeCheckIndex = 0;
      }


      const selected_subjectCheckIndex = sessionStorage.getItem('selected_subjectCheckIndex');
      console.log('selected_subjectCheckIndex', selected_subjectCheckIndex)
      if (selected_subjectCheckIndex) {
        this.subjectCheckIndex = parseInt(selected_subjectCheckIndex);
      } else {
        this.subjectCheckIndex = 1;
      }
      document.addEventListener('click', (e) => {
        if (!this.$el.contains(e.target)) {
          this.isOpen = false;
        }
      });
    },
    beforeDestroy() {
      document.body.style.overflow = '';
      // 当组件销毁时，恢复 body 的背景颜色
      document.body.style.backgroundColor = '';
    },
    created() {
      let font_size = localStorage.getItem('FontSizeValue');
      if (font_size) {
        this.FontSizeValue = font_size
      }
      this.getInformation()
    },
    methods: {
      handleSizeSelect(value) {
        this.FontSizeValue = value === '0' ? '' : value;
        localStorage.setItem('FontSizeValue', this.FontSizeValue || '');
        this.isOpen = false; // 选中后关闭菜单
      },
      async getInformation() {
        this.user = await this.axios.post('/user/information')
        let baseUrl = this.base_url
        let url =
          `${baseUrl+'/api/Auth/getWechatUrl?share_id='+this.user.id+'&scene=get_auth_link'}`
        this.qrCodeValue = url
        console.log(this.qrCodeValue)
        this.shareQrcode = this.user.shareQrcode

        if (this.user.fatherId > 0 && this.user.shareBonus <= 0) {
          this.childAuth = false
        }
      },
      showEndTime() {
        let that = this
        let msg = '到期时间：'
        if (!this.user) {
          msg = '请先登录'
        }
        msg += this.user.end
        if (this.user.shareBonus > 0) {
          msg += ' ~~  可设置VIP推广价格'
          this.$prompt(msg, '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'number',
            inputValue: this.user.sharePrice
          }).then(({
            value
          }) => {
            if (value) {
              that.setPrice(value)
            }
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '取消输入'
            // });
          });
        } else {
          this.$alert(msg, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
        }

      },
      setFontSize(value) {
        console.log('value', value)
        if (value > 0) {
          localStorage.setItem('FontSizeValue', value);
        } else {
          value = ''
          localStorage.removeItem('FontSizeValue');
        }
        this.FontSizeValue = value
      },
      setPrice(price) {
        let that = this
        that.axios
          .post('/user/setVipPrice', {
            price: price
          })
          .then(res => {
            console.log('res', res)
            if (res.ok == 1) {
              that.getInformation()
              that.$message({
                type: 'success',
                message: res.msg
              });
            } else {
              that.$message({
                type: 'info',
                message: res.msg
              });
            }

          })
          .catch(error => {
            that.$message({
              type: 'info',
              message: error.msg
            });
          })
      },
      selectVehicle(vehicle) {
        this.selectedVehicle = vehicle;
        console.log('选中车辆:', vehicle.title);
        // 这里可以添加车辆选择后的逻辑
      },
      selectBusiness(business) {
        this.selectedBusiness = business;
        console.log('选中业务:', business.text);
        // 这里可以添加业务选择后的逻辑
      },
      goVip() {
        if (this.childAuth == false) {
          this.$message.error('暂无练题权限');
          return;
        }
        let car_type_arr = this.vehicleTypes[this.carTypeCheckIndex] // 车型参数数组
        let subject_arr = this.vehicleTypes[this.subjectCheckIndex] // 科目参数数组
        // 存储对象（需先转为JSON字符串）
        const classify_pageParams = {
          ClassifyName: 'VIP题库',
          CarTypeName: car_type_arr['title'],
          car_type: car_type_arr['car_type'],
          SubjectName: subject_arr['text'],
          subject: subject_arr['subject'],
          Action: 'VIP题库'
        };
        localStorage.setItem('classify_pageParams', JSON.stringify(classify_pageParams));

        this.$Go('classify', {})
      },
      goSimulate() {
        if (this.childAuth == false) {
          this.$message.error('暂无练题权限');
          return;
        }
        this.showModal = true
      },
      selectFunction(item, index) {
        console.log('前往功能:', item);
        console.log('index:', index);

        if (this.childAuth === false) {
          this.$message.error('暂无练题权限');
          return;
        }

        if ([0, 2, 4, 6, 8].includes(index) == true) {
          this.carTypeCheckIndex = index // 设置数组索引

          sessionStorage.setItem('selected_carTypeCheckIndex', this.carTypeCheckIndex);
        }
        if ([1, 3, 5, 7, 9].includes(index) == true) {
          this.subjectCheckIndex = item.subject_key

          sessionStorage.setItem('selected_subjectCheckIndex', this.subjectCheckIndex);
        }
        // 当选择选择跟“三力测试”有关的时候，全部默认为三力测试选项
        if ([8, 9].includes(index) == true) {
          this.carTypeCheckIndex = 8
          this.subjectCheckIndex = 9
        }
        // 当选择注销恢复、满分学习的时候，直接进入分类页
        // if ([5, 7].includes(index) == true) {
        //   let car_type_arr = this.vehicleTypes[this.carTypeCheckIndex] // 车型参数数组
        //   let subject_arr = this.vehicleTypes[this.subjectCheckIndex] // 科目参数数组
        //   // 存储对象（需先转为JSON字符串）
        //   const classify_pageParams = {
        //     ClassifyName: item.text,
        //     CarTypeName: car_type_arr['title'],
        //     car_type: car_type_arr['car_type'],
        //     SubjectName: subject_arr['text'],
        //     subject: subject_arr['subject'],
        //     Action: item.Action
        //   };
        //   localStorage.setItem('classify_pageParams', JSON.stringify(classify_pageParams));
        //   console.log(JSON.stringify(classify_pageParams))
        //   this.$Go('classify', {})
        // }
      },
      goFunction(item, index) {
        if (this.childAuth == false) {
          this.$message.error('暂无练题权限');
          return;
        }

        if (item.Action == '成绩与错题') {
          this.$router.push('/recode?status=1')
          return
        }
        if (item.Action == '收藏题') {
          this.$Go('case', {
            txt: '收藏库'
          })
          return
        }
        if (item.Action == '使用流程') {

          let that = this
          that.axios
            .post('/index/pcVideo', {

            })
            .then(res => {
              if (res) {
                // window.location.href = res
                // 创建视频播放弹窗容器
                const videoModal = document.createElement('div');
                videoModal.className = 'video-modal';
                videoModal.style.cssText = `
                          position: fixed;
                          top: 0;
                          left: 0;
                          width: 100%;
                          height: 100%;
                          background: rgba(0,0,0,0.85);
                          z-index: 9999;
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          justify-content: center;
                          padding: 20px;
                          box-sizing: border-box;
                          opacity: 0;
                          animation: fadeIn 0.3s ease-out forwards;
                        `;

                // 添加淡入动画
                const style = document.createElement('style');
                style.textContent = `
                          @keyframes fadeIn {
                            from { opacity: 0; }
                            to { opacity: 1; }
                          }
                          @keyframes pulse {
                            0% { transform: scale(1); }
                            50% { transform: scale(1.05); }
                            100% { transform: scale(1); }
                          }
                          .control-bar {
                            opacity: 0;
                            transition: opacity 0.3s ease;
                          }
                          .video-container:hover .control-bar {
                            opacity: 1;
                          }
                        `;
                document.head.appendChild(style);

                // 创建视频容器（用于控制布局和控件）
                const videoContainer = document.createElement('div');
                videoContainer.className = 'video-container';
                videoContainer.style.cssText = `
                          position: relative;
                          max-width: 100%;
                          max-height: 80vh;
                          width: 100%;
                          margin-bottom: 25px;
                          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
                          border-radius: 8px;
                          overflow: hidden;
                        `;

                // 创建视频元素并禁用默认控件和画中画功能
                const video = document.createElement('video');
                video.src = res; // 后端应返回带时效的签名URL
                video.controls = false; // 禁用浏览器默认控件
                video.disablePictureInPicture = true; // 禁用画中画功能
                video.style.width = '100%';
                video.style.height = 'auto';
                video.style.maxHeight = '80vh';
                video.oncontextmenu = (e) => e.preventDefault(); // 禁用右键菜单

                // 创建底部控制栏（居中对齐）
                const controlBar = document.createElement('div');
                controlBar.className = 'control-bar';
                controlBar.style.cssText = `
                          position: absolute;
                          bottom: 0;
                          left: 0;
                          right: 0;
                          background: linear-gradient(transparent, rgba(0,0,0,0.8));
                          padding: 25px 20px; /* 增加内边距以适应大按钮 */
                          display: flex;
                          align-items: center;
                          justify-content: center; /* 水平居中 */
                          gap: 20px; /* 增加按钮间距 */
                          z-index: 10;
                        `;

                // 添加自定义播放/暂停按钮（增大尺寸并显示文字）
                const playPauseBtn = document.createElement('button');
                playPauseBtn.textContent = '播放';
                playPauseBtn.style.cssText = `
                          padding: 12px 24px; /* 增大内边距 */
                          border-radius: 6px;
                          background: rgba(255,255,255,0.2);
                          color: white;
                          border: none;
                          cursor: pointer;
                          font-size: 16px; /* 增大字体 */
                          font-weight: 500;
                          transition: all 0.2s ease;
                          backdrop-filter: blur(3px);
                          display: flex;
                          align-items: center;
                          gap: 8px;
                        `;
                playPauseBtn.onmouseover = () => {
                  playPauseBtn.style.background = 'rgba(255,255,255,0.3)';
                  playPauseBtn.style.transform = 'scale(1.05)';
                };
                playPauseBtn.onmouseout = () => {
                  playPauseBtn.style.background = 'rgba(255,255,255,0.2)';
                  playPauseBtn.style.transform = 'scale(1)';
                };
                playPauseBtn.onclick = () => {
                  if (video.paused) {
                    video.play();
                    playPauseBtn.textContent = '暂停';
                    playPauseBtn.style.animation = 'pulse 1s ease-in-out';
                    setTimeout(() => {
                      playPauseBtn.style.animation = '';
                    }, 1000);
                  } else {
                    video.pause();
                    playPauseBtn.textContent = '播放';
                  }
                };

                // 添加关闭按钮（增大尺寸并显示文字）
                const closeBtn = document.createElement('button');
                closeBtn.textContent = '关闭';
                closeBtn.style.cssText = `
                          padding: 12px 24px; /* 增大内边距 */
                          border-radius: 6px;
                          background: rgba(231, 76, 60, 0.7);
                          color: white;
                          border: none;
                          cursor: pointer;
                          font-size: 16px; /* 增大字体 */
                          font-weight: 500;
                          transition: all 0.2s ease;
                          backdrop-filter: blur(3px);
                          display: flex;
                          align-items: center;
                          gap: 8px;
                        `;
                closeBtn.onmouseover = () => {
                  closeBtn.style.background = 'rgba(231, 76, 60, 0.9)';
                  closeBtn.style.transform = 'scale(1.05)';
                };
                closeBtn.onmouseout = () => {
                  closeBtn.style.background = 'rgba(231, 76, 60, 0.7)';
                  closeBtn.style.transform = 'scale(1)';
                };
                closeBtn.onclick = () => {
                  videoModal.style.opacity = '0';
                  setTimeout(() => {
                    document.body.removeChild(videoModal);
                    document.head.removeChild(style); // 清理样式
                  }, 300);
                };

                // 组合元素并添加到页面
                controlBar.appendChild(playPauseBtn);
                controlBar.appendChild(closeBtn);
                videoContainer.appendChild(video);
                videoContainer.appendChild(controlBar);
                videoModal.appendChild(videoContainer);
                document.body.appendChild(videoModal);

                // 增强防下载措施
                video.ondragstart = (e) => e.preventDefault();
                video.onselectstart = (e) => e.preventDefault();

                // 监听视频播放结束，恢复按钮状态
                video.onended = () => {
                  playPauseBtn.textContent = '播放';
                };

                // 防止通过开发者工具获取视频源的简单措施
                Object.defineProperty(video, 'src', {
                  writable: false,
                  configurable: false
                });

              } else {
                that.$message({
                  type: 'info',
                  message: '视频未录制'
                });
              }

            })
            .catch(error => {
              that.$message({
                type: 'info',
                message: error.msg
              });
            })
          return
        }
        let car_type_arr = this.vehicleTypes[this.carTypeCheckIndex] // 车型参数数组
        let subject_arr = this.vehicleTypes[this.subjectCheckIndex] // 科目参数数组
        // 存储对象（需先转为JSON字符串）
        const classify_pageParams = {
          ClassifyName: item.text,
          CarTypeName: car_type_arr['title'],
          car_type: car_type_arr['car_type'],
          SubjectName: subject_arr['text'],
          subject: subject_arr['subject'],
          Action: item.Action
        };

        if (item.Action == '三力测试') {
          // 三力测试的时候，科目定义为 7
          classify_pageParams.subject = 7
          classify_pageParams.SubjectName = '三力测试'
        }
        localStorage.setItem('classify_pageParams', JSON.stringify(classify_pageParams));
        localStorage.setItem('CarTypeName', classify_pageParams.CarTypeName);
        this.$Go('classify', {})
      },
      goExam(txt, source) {
        localStorage.setItem('CarTypeName', this.vehicleTypes[this.carTypeCheckIndex]['title']);
        console.log('vehicleTypesvehicleTypes', this.vehicleTypes[this.carTypeCheckIndex]['title'])
        this.closeModal()
        if (source == 'CaseScene') {
          this.$Go('CaseScene', {
            txt: txt,
            car: this.vehicleTypes[this.carTypeCheckIndex]['title'],
            carId: this.vehicleTypes[this.carTypeCheckIndex]['car_type'],
            subject: this.vehicleTypes[this.subjectCheckIndex]['text'],
            subjectId: this.vehicleTypes[this.subjectCheckIndex]['subject']
          })
        } else {
          this.$Go('case', {
            txt: txt,
            car: this.vehicleTypes[this.carTypeCheckIndex]['title'],
            carId: this.vehicleTypes[this.carTypeCheckIndex]['car_type'],
            subject: this.vehicleTypes[this.subjectCheckIndex]['text'],
            subjectId: this.vehicleTypes[this.subjectCheckIndex]['subject']
          })
        }


      },
      open() {
        this.$confirm('此操作将退出登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.localStorage.removeItem('userInfo')
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          this.$router.replace('/register')
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      closeModal() {
        this.showModal = false;
      },
      toUser() {
        this.$Go('user', {})
      }
    }
  }
</script>
<style scoped>
  /* 新增：确保 html/body 无默认边距且高度占满 */
  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
    /* 禁止页面整体滚动（避免全屏时出现滚动条留白） */
  }

  .container {
    background-color: #4da6ff;
    min-height: 100vh;
    /* 改用 vh 单位，强制与视口高度一致 */
    height: 100%;
    /* 补充高度属性，避免内容不足时出现空白 */
    overflow-y: auto;
    /* 允许容器内部滚动（替代 body 滚动） */
  }

  /* 分割线 */
  .middle-thick-divider {
    height: 1.5rem;
    /* 分割线最大高度（中间的粗细） */
    background: radial-gradient(circle at center,
        #99d9f4 0%,
        /* 中心颜色（中间最粗） */
        #99d9f4 30%,
        /* 渐变范围：中间 30% 保持最大宽度 */
        transparent 100%
        /* 两端透明，实现“收窄” */
      );
    /* 让背景只横向重复（可选，适配长页面） */
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }


  /* 整体容器样式 */
  .exam-menu-container {
    display: flex;
    justify-content: space-between;
    padding: 2rem;
    border-radius: 1rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    /* gap: clamp(1rem, 2vw, 2rem); */
    margin: 0 auto;
  }


  .section-title {
    font-size: clamp(1rem, 2vw, 1.25rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    font-weight: 600;
    margin-bottom: clamp(1rem, 1.5vw, 1.25rem);
    /* 使用clamp函数根据视口宽度调整边距 */
    padding-bottom: clamp(0.5rem, 1vw, 0.75rem);
    /* 使用clamp函数根据视口宽度调整边距 */
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  /* 功能分组样式 */
  .function-group {
    margin-bottom: clamp(1rem, 1.5vw, 1.5rem);
    /* 使用clamp函数根据视口宽度调整边距 */
  }

  .group-title {
    font-size: clamp(0.875rem, 1.5vw, 1rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    font-weight: 500;
    margin-bottom: clamp(0.5rem, 1vw, 0.75rem);
    /* 使用clamp函数根据视口宽度调整边距 */
    color: rgba(255, 255, 255, 0.8);
  }

  /* 车辆类型样式 */
  .vehicle-type {
    display: flex;
    align-items: center;
    gap: clamp(0.75rem, 1.5vw, 1rem);
    /* 使用clamp函数根据视口宽度调整间距 */
    padding: clamp(0.5rem, 1vw, 0.75rem) clamp(0.75rem, 1.5vw, 1rem);
    /* 使用clamp函数根据视口宽度调整内边距 */
    border-radius: 0.5rem;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .vehicle-type:hover,
  .vehicle-type.active {
    background: rgba(255, 255, 255, 0.15);
    transform: translateX(5px);
  }

  .vehicle-type .iconfont {
    font-size: clamp(1.25rem, 2vw, 1.5rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    width: clamp(1.5rem, 2vw, 2rem);
    /* 使用clamp函数根据视口宽度调整宽度 */
    text-align: center;
  }

  .type-info {
    display: flex;
    flex-direction: column;
  }

  .type-title {
    font-size: 1.8rem;
    font-weight: 500;
  }

  .type-sub {
    font-size: 1rem;
    opacity: 0.8;
  }

  /* 业务项样式 */
  .business-item {
    display: flex;
    align-items: center;
    gap: clamp(0.75rem, 1.5vw, 1rem);
    /* 使用clamp函数根据视口宽度调整间距 */
    padding: clamp(0.5rem, 1vw, 0.75rem) clamp(0.75rem, 1.5vw, 1rem);
    /* 使用clamp函数根据视口宽度调整内边距 */
    border-radius: 0.5rem;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .business-item:hover,
  .business-item.active {
    background: rgba(255, 255, 255, 0.15);
    transform: translateX(5px);
  }

  .business-item .iconfont {
    font-size: clamp(1rem, 1.5vw, 1.25rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    width: clamp(1.25rem, 1.5vw, 1.75rem);
    /* 使用clamp函数根据视口宽度调整宽度 */
    text-align: center;
  }

  /* 中间区域样式 */
  .middle-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: clamp(1.5rem, 2vw, 2rem);
    /* 使用clamp函数根据视口宽度调整间距 */
    flex: 0.8;
  }

  /* 原来不用图片的 */
  .vip-box22222222 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ffd700 0%, #ffb347 100%);
    width: clamp(6rem, 10vw, 8rem);
    /* 使用clamp函数根据视口宽度调整尺寸 */
    height: clamp(6rem, 10vw, 8rem);
    /* 使用clamp函数根据视口宽度调整尺寸 */
    border-radius: 50%;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 30px rgba(255, 215, 0, 0.3);
  }

  /* 原来不用图片的 */
  .vip-box {
    background-image: url('/static/img/VIP.png');
    width: 11rem;
    /* 使用clamp函数根据视口宽度调整尺寸 */
    height: 11rem;
    /* 使用clamp函数根据视口宽度调整尺寸 */
    cursor: pointer;
    background-size: cover;
  }



  .vip-box:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 35px rgba(255, 215, 0, 0.4);
  }

  .diamond {
    font-size: clamp(2rem, 4vw, 2.5rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    line-height: 1;
  }

  .vip-text {
    font-size: clamp(1.25rem, 2vw, 1.5rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    font-weight: bold;
    margin-top: clamp(0.125rem, 0.5vw, 0.25rem);
    /* 使用clamp函数根据视口宽度调整边距 */
  }

  .vip-desc {
    font-size: clamp(0.625rem, 1vw, 0.75rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    margin-top: clamp(0.0625rem, 0.25vw, 0.125rem);
    /* 使用clamp函数根据视口宽度调整边距 */
  }

  .simulate-exam {
    background-image: url('/static/img/test.png');
    width: 11rem;
    /* 使用clamp函数根据视口宽度调整尺寸 */
    height: 11rem;
    /* 使用clamp函数根据视口宽度调整尺寸 */
    cursor: pointer;
    background-size: cover;
  }

  .simulate-exam:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 35px rgba(255, 215, 0, 0.4);
  }

  .simulate-exam2222 {
    display: flex;
    align-items: center;
    gap: clamp(0.5rem, 1vw, 0.75rem);
    /* 使用clamp函数根据视口宽度调整间距 */
    background: rgba(255, 255, 255, 0.1);
    padding: clamp(0.5rem, 1vw, 0.75rem) clamp(1rem, 1.5vw, 1.5rem);
    /* 使用clamp函数根据视口宽度调整内边距 */
    border-radius: 9999px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  }

  .simulate-exam2222:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }

  .simulate-exam2222 .iconfont {
    font-size: clamp(1rem, 1.5vw, 1.25rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
  }

  /* 右侧功能区域 */
  .right-section {
    flex: 1.2;
  }

  .section-title {
    font-size: clamp(1rem, 1.5vw, 1.125rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    font-weight: 600;
    margin-bottom: clamp(0.75rem, 1vw, 1rem);
    /* 使用clamp函数根据视口宽度调整边距 */
    padding-bottom: clamp(0.25rem, 0.5vw, 0.5rem);
    /* 使用clamp函数根据视口宽度调整边距 */
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .function-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: clamp(0.75rem, 1vw, 1rem);
    /* 使用clamp函数根据视口宽度调整间距 */
  }

  .function-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    padding: 1.25rem;
    /* 使用clamp函数根据视口宽度调整内边距 */
    border-radius: 0.75rem;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
  }

  .function-item:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-3px);
  }

  .function-item-img {
    width: 6.25rem;
    height: 2.5rem;
  }

  .function-item-img2 {
    width: 3.5rem;
    height: 3.5rem;
  }

  .car-type-check {
    background-color: #ffaa00 !important;
  }

  .subject-check {
    color: red;
    font-size: 1rem;
    font-weight: 600;
  }

  .item-icon {
    font-size: clamp(1.25rem, 2vw, 1.5rem);
    /* 使用clamp函数根据视口宽度调整字体大小 */
    margin-bottom: clamp(0.25rem, 0.5vw, 0.5rem);
    /* 使用clamp函数根据视口宽度调整边距 */
    width: clamp(2.5rem, 4vw, 3rem);
    /* 使用clamp函数根据视口宽度调整尺寸 */
    height: clamp(2.5rem, 4vw, 3rem);
    /* 使用clamp函数根据视口宽度调整尺寸 */
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
  }

  /* // 考试确认框模态框 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .rule-item {
    margin-bottom: 0.625rem;
  }

  .tip-text {
    color: red;
    margin-bottom: 0.625rem;
  }

  .operation-tip {
    color: #666;
    font-size: 1.125rem;
    margin: 1.25rem 1.25rem 0 0;
  }

  /* // 考试确认框模态框 - 结束 */

  .qr-code-wrapper {
    display: inline-block;
    /* 确保包裹元素只占内容大小 */
    padding: 0.5rem;
    /* 使用 padding 替代 margin */
    background-color: white;
    /* 与二维码背景色一致 */
  }

  .alignItemsToLeft {
    align-items: flex-start !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/home.vue